import { basic, initSidebar, initTopbar } from './modules/layouts';
import { categoryCollapse } from './modules/components';

basic();
initSidebar();
initTopbar();
categoryCollapse();
